<template>
  <section class="relative">
    <div class="container pt-8 pb-24 sm:pt-24">
      <article class="two-column leading-loose" v-html="htmlString"/>
    </div>
    <div class="absolute top-23-5 -bottom-40 left-0 right-0 before-bg -z-1"/>
  </section>
</template>

<script>
export default {
  props: {
    htmlString: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="sass" scoped>
.before-bg
  background: url("~assets/img/bg-linkrow.svg") no-repeat top / cover

.two-column
  & > ::v-deep div
    display: flex
    flex-direction: column
    justify-content: space-between
    @media(min-width: theme('screens.md'))
      flex-direction: row

    & > div
      width: 100%
      padding-bottom: 1rem
      @media(min-width: theme('screens.md'))
        width: 40%

</style>
